(function () {
  let selectedProvider = '';

  function applyState() {
    const select = document.getElementById('qc-provider-credit');
    const checkoutBtn = document.getElementById('qc-checkout-btn');
    if (!select || !checkoutBtn) return;

    if (selectedProvider && select.value !== selectedProvider) {
      select.value = selectedProvider;
    }

    const valid = select.value !== '';
    checkoutBtn.disabled = !valid;
    checkoutBtn.style.opacity = valid ? '' : '0.4';
    checkoutBtn.style.pointerEvents = valid ? '' : 'none';
    checkoutBtn.style.cursor = valid ? '' : 'not-allowed';
  }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'qc-provider-credit') return;
    selectedProvider = e.target.value;
    applyState();
  }, true);

  document.addEventListener('submit', function (e) {
    if (!e.target || !e.target.classList.contains('quick-cart__form')) return;
    const select = document.getElementById('qc-provider-credit');
    if (select && select.value === '') {
      e.preventDefault();
      e.stopImmediatePropagation();
      select.style.borderColor = '#c0392b';
      select.focus();
    }
  }, true);

  new MutationObserver(function (mutations) {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.id === 'qc-checkout-btn' || node.id === 'qc-provider-credit' ||
            (node.querySelector && (node.querySelector('#qc-checkout-btn') || node.querySelector('#qc-provider-credit')))) {
          setTimeout(applyState, 30);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyState);
  } else {
    applyState();
  }
})();